import AttachmentsViewer from './attachments-viewer';

export default AttachmentsViewer;
